import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import InstructorSidebar from "../common/instructorSidebar";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDispatch } from "react-redux";
import {
  disableEnableButton,
  getDashboardData,
  getDisableEnableButton,
} from "utils/quizThunk";
import toast from "react-hot-toast";
const InstructorDashboard = () => {
  const [isResultActionEnabled, setIsResultActionEnabled] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [nextToggleValue, setNextToggleValue] = useState(false);
  const dispatch = useDispatch();
  const [stats, setStats] = useState({});
  const [courses, setCourses] = useState([]);
  async function getData() {
    const data = await dispatch(getDashboardData());
    if (data?.payload?.success) {
      setStats(data?.payload?.stats || {});
    }
  }
  async function getDisableEnableData() {
    const data = await dispatch(getDisableEnableButton());
    if (data?.payload?.success) {
      setIsResultActionEnabled(data?.payload?.data?.isPass || false);
      setNextToggleValue(data?.payload?.data?.isPass || false);
    }
  }
  useEffect(() => {
    getData();
    getDisableEnableData();
  }, []);
  const handleDisableEnable = async () => {
    const res = await dispatch(
      disableEnableButton({ isPass: nextToggleValue })
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.message);
    } else {
      toast.error(res?.payload?.message);
    }
  };

  return (
    <>
      <Breadcrumb title="Dashboard" />
      <div className="content">
        <div className="container">
          {/* <ProfileCard /> */}
          <div className="row">
            {/* Sidebar */}
            <InstructorSidebar />
            {/* /Sidebar */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                          <ImageWithBasePath
                            src="assets/img/icon/graduation.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <span className="d-block">Enrolled Student</span>
                          <h4 className="fs-24 mt-1">
                            {stats?.totalUsers || 0}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                          <ImageWithBasePath
                            src="assets/img/icon/book.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <span className="d-block">Total Quizzes</span>
                          <h4 className="fs-24 mt-1">
                            {stats?.totalQuizzes || 0}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                          <ImageWithBasePath src="assets/img/icon/bookmark.svg" alt="" />
                        </span>
                        <div>
                          <span className="d-block">Total Exams</span>
                          <h4 className="fs-24 mt-1">{stats?.totalCourses}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-start">
                         <span className="icon-box bg-success-transparent flex-shrink-0">
                          <i className="bi bi-toggle2-on fs-3 text-success"></i>
                        </span>
                        <div className="mx-3">
                          <span className="d-block mb-1">
                            Toggle Result Action
                          </span>
                          <div className="form-check form-switch ">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="toggleResultAction"
                              checked={isResultActionEnabled}
                              onChange={(e) => {
                                setNextToggleValue(e.target.checked);
                                setShowConfirmModal(true);
                                console.log(
                                  "e.target.checked---->",
                                  e.target.checked
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="toggleResultAction"
                            >
                              {isResultActionEnabled ? "Enabled" : "Disabled"}
                            </label>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <h5 className="mb-3 fw-bold">Recently Created Exams</h5> */}
              {/* <div className="table-responsive custom-table">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>Courses</th>
                      <th>Enrolled</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses?.length > 0 ? (
                      courses?.slice(0, 5)?.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <div className="course-title d-flex align-items-center">
                              <Link
                                // to={all_routes.courseDetails2}
                                className="avatar avatar-xl flex-shrink-0 me-2"
                              >
                                <ImageWithBasePath
                                  src={
                                    item?.courseThumnail?.path ||
                                    "assets/img/instructor/instructor-table-01.jpg"
                                  }
                                  alt="Img"
                                />
                              </Link>
                              <div>
                                <p className="fw-medium">
                                  <Link>{item?.courseTitle || "NA"}</Link>
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>{item?.purchasedCourse?.length}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className="position-relative">
                        <td className="text-center" colSpan={2}>
                          <p>No Exams Created</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade show"
        style={{ display: showConfirmModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Action</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to{" "}
                {nextToggleValue ? "enable" : "disable"} result action?
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary mx-2"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDisableEnable();
                  setIsResultActionEnabled(nextToggleValue);
                  setShowConfirmModal(false);
                }}
              >
                Yes, {nextToggleValue ? "Enable" : "Disable"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showConfirmModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default InstructorDashboard;
